import React, { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import './PdfViewer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: false,
};

function PdfViewer(props) {
    const [width, setWidth] = useState(null);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [scale, zoom] = useState(1.0);

    function onDocumentLoadSuccess(pdf) {
        setNumPages(pdf.numPages);
    }

    function addPageNumber(addPage) {
        var newPageNumber = pageNumber + addPage;
        if (newPageNumber >= 1 && newPageNumber <= numPages) {
            setPageNumber(newPageNumber);
        }
    }

    function handleZoom(addZoom) {
        var newScale = scale + addZoom;
        if (newScale >= 0.2 && newScale <= 3) {
            zoom(newScale);
            
        }
    }

    useEffect(() => {
        const handleResize = () => setWidth(getParentWidt());
        
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

    function getParentWidt(){
        return document.getElementById(props.parentId).offsetWidth;
    }

    function onPageLoadSuccess(page){
        setWidth(getParentWidt());
    }

    return (
        <div className="pdfViewer">
            <div className="pageNavigation centerHorizontal">
                    <span className="navigate" onClick={() => addPageNumber(-1)}>
                        <i className="fas fa-arrow-circle-left"></i></span> {pageNumber} av {numPages}
                    <span className="navigate" onClick={() => addPageNumber(1)}> <i className="fas fa-arrow-circle-right"></i>
                    </span>
                    <span className="zoom">
                        <span className="navigate" onClick={() => handleZoom(-0.2)}> <i className="fas fa-search-minus"></i>
                        </span>
                        <span className="navigate" onClick={() => handleZoom(0.2)}> <i className="fas fa-search-plus"></i>
                        </span>
                    </span>

                </div>
            <Document
                className="pdfDocument"
                file={props.file}
                onLoadSuccess={onDocumentLoadSuccess}
                options={options}
                loading={<div className="loader"></div>}
            >
                <Page
                    onLoadSuccess={onPageLoadSuccess}
                    pageNumber={pageNumber}
                    width={width}
                    scale={scale}
                />
                
            </Document>
            
        </div>
    );
}

export default PdfViewer;